import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, ShoppingCart, X, ArrowRight } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/pixel';
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}) {
  const handleClick = () => {
    // Meta Pixel: every CTA click is an InitiateCheckout funnel signal
    const label = typeof children === 'string' ? children : 'CTA — Ciudadanía Pack';
    trackInitiateCheckout({
      content_name: label
    });
    if (onClick) {
      onClick();
      return;
    }
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-brand-600 hover:bg-brand-700 text-white font-display font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_4px_0_0_#5b21b6] hover:shadow-[0_2px_0_0_#5b21b6] hover:translate-y-[2px] transition-all flex items-center justify-center gap-2 w-full md:w-auto ${className}`} data-id="element-317">
      {children}
    </motion.button>;
}
export function CountdownTimer({
  className = ''
}: {
  className?: string;
}) {
  // Start at 23:55:51
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 55 * 60 + 51);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className={`flex items-center gap-2 text-2xl md:text-4xl font-display font-bold text-brand-900 ${className}`} data-id="element-318">
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-slate-200 min-w-[2.5ch] text-center" data-id="element-319">
        {hours.toString().padStart(2, '0')}
      </div>
      <span className="text-slate-400" data-id="element-320">:</span>
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-slate-200 min-w-[2.5ch] text-center" data-id="element-321">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className="text-slate-400" data-id="element-322">:</span>
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-slate-200 min-w-[2.5ch] text-center" data-id="element-323">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
}
const names = ['María', 'Juan', 'Sofía', 'Lucas', 'Valentina', 'Mateo', 'Camila', 'Santiago', 'Florencia', 'Diego', 'Agustina', 'Martín', 'Julieta', 'Nicolás', 'Carolina'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Corrientes'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(triggerPopup, 30000);
    const interval = setInterval(() => {
      triggerPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-324">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-slate-100 p-4 max-w-[320px] flex items-start gap-3" data-id="element-325">
          <div className="bg-brand-50 p-2.5 rounded-full text-brand-600 shrink-0" data-id="element-326">
            <ShoppingCart className="w-5 h-5" data-id="element-327" />
          </div>
          <div className="flex-1 pr-4" data-id="element-328">
            <p className="text-sm font-medium text-slate-900 leading-tight" data-id="element-329">
              <span className="font-bold" data-id="element-330">{data.name}</span> de {data.city}{' '}
              acaba de comprar el Pack Completo
            </p>
            <p className="text-xs text-slate-500 mt-1.5 flex items-center gap-1" data-id="element-331">
              <MapPin className="w-3 h-3" data-id="element-332" /> Hace {data.time} minuto
              {data.time !== 1 ? 's' : ''}
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600 absolute top-2 right-2" data-id="element-333">
            <X className="w-4 h-4" data-id="element-334" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}